<template>
    <v-card flat>
        <v-card-title>
            {{ name }}
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="primary"
                class="mb-2"
                :to="{ name: 'CadastrarDemandaStaff', params: { requesterType: 'juridico', requesterId: this.id } }"
            >
                <v-icon>add</v-icon> {{ $t('common.tabDemands.addItem') }}
            </v-btn>
        </v-card-title>

        <v-tabs
            v-model="activeTab"
            background-color="white"
            color="primary"
            centered
        >
            <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" exact>
                {{ tab.name }}
            </v-tab>

            <v-tabs-items v-model="activeTab">
                <router-view></router-view>
            </v-tabs-items>
        </v-tabs>
    </v-card>
</template>

<script>
import API from '@/api'

export default {
    name: 'detail-tab-demand',
    props: ['id'],
    data: function () {
        return {
            name: '',
            activeTab: `/juridico/detalhe/${this.id}/demandas/ativas`,
            tabs: [
                { id: 1, name: this.$t('common.tabDemands.tabs.actives'), route: `/juridico/detalhe/${this.id}/demandas/ativas` },
                { id: 2, name: this.$t('common.tabDemands.tabs.completeds'), route: `/juridico/detalhe/${this.id}/demandas/finalizadas` },
                { id: 3, name: this.$t('common.tabDemands.tabs.standby'), route: `/juridico/detalhe/${this.id}/demandas/standby` }
            ]
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        loadData () {
            this.loading = true
            let endpoint = API.EndPoints.getUserCompanyDetail
            endpoint.id = this.$route.params.id
            let params = {
                include: ['user.name']
            }
            new API(endpoint, params).request().then(response => {
                this.name = response.data.user.name
                this.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
